export default "__VITE_ASSET__IOXumEY1__"